<template>
	<div>
		<h3>
			<label>{{ label }}</label>
			<span v-if="required" class="required-field">*</span>
		</h3>
		<div class="check_item">
			<input
				type="checkbox"
				:id="name"
				name="agree_checkbox"
				v-model="inputValue"
				true-value="checked"
				false-value=""
			/>
			<label :for="name"> {{ placeholder }} </label>
		</div>
	</div>
</template>

<script>
import { computed } from 'vue';

export default {
	name: 'InputCheckbox',
	props: {
		label: {
			type: String,
		},
		placeholder: {
			type: String,
		},
		type: {
			type: String,
			default: 'text',
		},
		value: {
			type: String,
		},
		name: {
			type: String,
		},
		required: {
			type: Boolean,
		},
	},
	setup(props, { emit }) {
		const inputValue = computed({
			get() {
				return props.value;
			},
			set(inputValue) {
				emit('update:value', inputValue);
			},
		});
		return { inputValue };
	},
};
</script>
